import { AppStore } from "./app-store/app-store";
import { SpaceStore } from "./space-store/space-store";

class DataStore {
  spaceStore: SpaceStore = new SpaceStore();
  appStore: AppStore = new AppStore();
}

export default DataStore;
